import { DFREE_GRAPH_VIEW_TYPE, DfreeGraphViewType } from '@/constants';

// たまり具合表示か
export const isValueView = (viewType: DfreeGraphViewType) => viewType === DFREE_GRAPH_VIEW_TYPE.Value;
// 尿量表示か
export const isVolumeView = (viewType: DfreeGraphViewType) => viewType === DFREE_GRAPH_VIEW_TYPE.Volume;
